module.exports = __webpack_public_path__ + "static/img/sector_bg.2d6148fc.png";